"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallationContactCms = void 0;
var InstallationContactCms = /** @class */ (function () {
    function InstallationContactCms() {
        this.installationContactLabel = 'Installation-day contact info';
        this.addLinkLabel = 'Edit contact info or add instructions';
        this.contactMissingLabel = 'Please provide us contact info for the day of installation.';
        this.updateLinkLabel = 'Update contact person or instructions';
        this.secondaryNumberLabel = 'Secondary contact number';
        this.instructionsLabel = 'Special instructions';
    }
    return InstallationContactCms;
}());
exports.InstallationContactCms = InstallationContactCms;
//# sourceMappingURL=InstallationContact.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationContact/InstallationContact.cms.js
// module id = 963
// module chunks = 8